import React from 'react';
import {
    Card,
    CardMedia,
    CardContent,
    Typography,
    Button,
    Box,
    Grid,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const PackageCard = ({ name, image, duration, price, destinationId, packageId, packageType }) => {
    const navigate = useNavigate();

    const handleViewDetails = () => {
        navigate(`/${packageType}/${destinationId}/${packageId}`);
    };

    return (
        <Box sx={{ height: '100%', overflow: 'visible' }}>
            <Card
                elevation={3}
                sx={{
                    height: '100%',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                    transformOrigin: 'center',
                    '&:hover': {
                        transform: 'scale(1.03) translateY(-6px)',
                        boxShadow: 6,
                    },
                }}
            >
                <CardMedia
                    component="img"
                    sx={{
                        height: 200,
                        width: "100%",
                        objectFit: 'cover',
                    }}
                    image={image}
                    alt={name}
                />
                <CardContent>
                    <Grid container alignItems="center" justifyContent="space-between">
                        <Grid item size={{xs: 8, md: 8, lg:6}} >
                            <Typography variant="subtitle1" sx={{
                                fontSize: {
                                    xs: '0.7rem',
                                    sm: '0.7rem'
                                }, fontWeight: 600
                            }}>
                                {name}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {duration}
                            </Typography>
                            <Typography variant="body2" sx={{ mt: 1, fontWeight: 'bold' }}>
                                {price}
                            </Typography>
                        </Grid>

                        <Grid item size={{xs: 4, md: 4, lg:6}} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button
                                variant="contained"
                                sx={{
                                    fontSize: {
                                        xs: '0.4rem',
                                        md: '0.4rem',
                                        lg : '0.7rem'
                                    },
                                    backgroundColor: '#0e8279',
                                    whiteSpace: 'nowrap',
                                }}
                                onClick={handleViewDetails}
                            >
                                View Details
                            </Button>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Box>
    );
};

export default PackageCard;
